import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Login from '@/views/Login.vue'
import Escritorio from '@/views/Escritorio.vue'
import Facturador from '@/views/Facturador.vue'
import Empresas from '@/views/Empresas.vue'
import { atexto, minix } from '@/components/functions/alertas'

Vue.use(VueRouter)

const routes = [
    {
        path: '*',
        redirect: '/login',
    },
    {
        path: '/',
        redirect: '/login',
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/escritorio',
        name: 'Escritorio',
        component: Escritorio,
        meta: {
            autentificado: true,
            permisoRequerido: 'ESCRITORIO'
        }
    },
    {
        path: '/facturador',
        name: 'Facturador',
        component: Facturador,
        meta: {
            autentificado: true,
            permisoRequerido: 'FACTURADOR'
        }
    },
    {
        path: '/empresas',
        name: 'Empresas',
        component: Empresas,
        meta: {
            autentificado: true
        }
    }

]

const router = new VueRouter({
    // mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {

    let origen = localStorage.getItem('fdb')
    let usuario

    if (origen == null || origen == '' || origen == undefined) { // verifica si existe localstoage
        usuario = false
    } else { // verifica si el token es valido o si existe token
        let parse_origen = JSON.parse(origen)

        if (parse_origen.token_sesion) {
            usuario = true
        } else {
            usuario = false
        }

    }

    let autorizado = to.matched.some(record => record.meta.autentificado)
    let requierePermiso = to.matched.some(record => record.meta.permisoRequerido)


    // La ruta require autenteticación

    if (usuario && to.path === '/login') { // usuario && to.path === '/login'
        // El usuario ya está autenticado e intenta acceder a la página de login
        next('/Escritorio')
    } else if (autorizado) { //autorizado && !usuario
        // next('login')

        if (!usuario) {
            // El usuario no está autenticado pero la ruta requiere autenticación
            next('login')
        } else if (requierePermiso) {
            // El usuario está autenticado y la ruta requiere un permiso específico
            if (store.getters.USER_HAS_PERMISSION(to.meta.permisoRequerido)) {
                next()
            } else {
                // El usuario no tiene los permisos necesarios
                next(false)
                atexto({ titulo: 'Alto!', cuerpo: 'No tienes acceso a esta ruta', icono: 'warning' })
            }
        } else {
            // El usuario está autenticado y la ruta no requiere permisos adicionales
            next()
        }

    } else {
        // La ruta no requiere autenticación
        next()
    }

})



export default router
